import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ref-modal',
  templateUrl: './ref-modal.component.html',
  styleUrls: ['./ref-modal.component.scss']
})
export class RefModalComponent implements OnInit {

  constructor(private router: Router,
    public dialogRef: MatDialogRef<RefModalComponent>) { }

  onClickYes(): void {
    this.dialogRef.close();
    // this.router.navigate(['/success']);
  }

  onClickNo(): void {
    this.dialogRef.close();
    this.router.navigate(['/success'], { queryParams: { error: true } });
  }

  ngOnInit() {
  }

}
